// @ts-nocheck
import React, { useState } from 'react';
import {
    Box,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button
} from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { CustomPaginationCommon } from 'modules/Users/components';
import { useNavigate, useParams } from 'react-router-dom';

const RefundsTable = () => {
    const navigate = useNavigate();
    const { userType } = useParams();

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // Sample data
    const payments = [
        { transactionID: '#123412451', date: 'June 1, 2024', contentName: 'Neuropsychology: Brain and Behavior', email: 'serraozk@mail.com', totalPaid: '$30' },
        { transactionID: '#123412451', date: 'June 1, 2024', contentName: 'Neuropsychology: Brain and Behavior', email: 'serraozk@mail.com', totalPaid: '$30' },
        { transactionID: '#123412451', date: 'June 1, 2024', contentName: 'Neuropsychology: Brain and Behavior', email: 'serraozk@mail.com', totalPaid: '$30' },
        { transactionID: '#123412451', date: 'June 1, 2024', contentName: 'Neuropsychology: Brain and Behavior', email: 'serraozk@mail.com', totalPaid: '$30' },
        { transactionID: '#123412451', date: 'June 1, 2024', contentName: 'Neuropsychology: Brain and Behavior', email: 'serraozk@mail.com', totalPaid: '$30' },
        { transactionID: '#123412451', date: 'June 1, 2024', contentName: 'Neuropsychology: Brain and Behavior', email: 'serraozk@mail.com', totalPaid: '$30' },
        { transactionID: '#123412451', date: 'June 1, 2024', contentName: 'Neuropsychology: Brain and Behavior', email: 'serraozk@mail.com', totalPaid: '$30' },
        { transactionID: '#123412451', date: 'June 1, 2024', contentName: 'Neuropsychology: Brain and Behavior', email: 'serraozk@mail.com', totalPaid: '$30' },
        // Repeat this object for more rows
    ];

    const handleChangePage = (event: any, newPage: React.SetStateAction<number>) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: { target: { value: string } }) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Grid display={"flex"} flexDirection={"column"} justifyContent={"center"} gap={5} px={5}>
            <Box pt={3} fontWeight={500} fontSize="28px" color="#233F91" display="flex" alignItems="center">
                <KeyboardArrowLeftIcon sx={{ color: "#233F91", fontSize: "28px" }} />
                Refund Requests
            </Box>
            <Grid item xs={10}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '35px' }}>
                    <div style={{ backgroundColor: '#EFF4FA', borderRadius: '15px', padding: '24px', display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ fontWeight: '700', fontSize: '17px', width: '12.5%' }}>User Name
                        </div>
                        <div style={{ fontWeight: '700', fontSize: '17px', width: '12.5%' }}>Email Address</div>
                        <div style={{ fontWeight: '700', fontSize: '17px', width: '12.5%' }}>Content Name
                        </div>
                        <div style={{ fontWeight: '700', fontSize: '17px', width: '12.5%' }}>Date</div>
                        <div style={{ fontWeight: '700', fontSize: '17px', width: '12.5%' }}>Action
                        </div>

                    </div>
                    <div style={{ backgroundColor: '#fff', borderRadius: '15px', padding: '24px', display: 'flex', flexDirection: 'column', gap: '28px' }}>
                        {payments.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((payment) => (
                            <div key={payment.transactionID} style={{
                                display: 'flex', justifyContent: 'space-between', fontSize: '19px', fontWeight: '500',
                                color: '#595959',
                                lineHeight: '28px',
                                fontFamily: "Nunito",
                            }}>
                                <div style={{ width: '12.5%' }}>{payment.transactionID}</div>
                                <div style={{ width: '12.5%' }}>{payment.date}</div>
                                <div style={{ width: '12.5%' }}>{payment.contentName}</div>
                                <div style={{ width: '12.5%' }}>{payment.email}</div>
                                <div style={{ width: '12.5%' }}>
                                    <Button variant="contained" sx={{
                                        borderRadius: '15px',
                                        width: '154px',
                                        height: '48px',
                                        textTransform: 'none',
                                        backgroundColor: '#233F91',
                                        color: '#FFFFFF',
                                        fontSize: '16px',
                                        fontWeight: 700,
                                        '&:hover': {
                                            backgroundColor: '#1565c0'
                                        }
                                    }}>
                                        View Receipt
                                    </Button>
                                </div>
                            </div>
                        ))}
                        <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
                            <CustomPaginationCommon
                                count={payments.length}
                                page={page}
                                rowsPerPage={rowsPerPage}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </div>
                    </div>
                </div>
                {/* <TableContainer >
                    <Table sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 5 }}>
                        <Paper sx={{
                            bgcolor: '#EFF4FA', borderRadius: "8px", width: "100%"
                        }}>
                            <TableHead>
                                <TableRow sx={{
                                    display: "flex", flexDirection: "row", justifyContent: "space-between",
                                    '& th': { fontWeight: 700, fontSize: '17px', }
                                }}>
                                    <TableCell sx={{ fontWeight: 700, fontSize: '17px' }}>Transaction ID</TableCell>
                                    <TableCell sx={{ fontWeight: 700, fontSize: '17px' }}>Date</TableCell>
                                    <TableCell sx={{ fontWeight: 700, fontSize: '17px' }}>Content Name</TableCell>
                                    <TableCell sx={{ fontWeight: 700, fontSize: '17px' }}>Email</TableCell>
                                    <TableCell sx={{ fontWeight: 700, fontSize: '17px' }}>Total Paid</TableCell>
                                    <TableCell sx={{ fontWeight: 700, fontSize: '17px' }}></TableCell>
                                </TableRow>
                            </TableHead>
                        </Paper>
                        <Paper sx={{
                            bgcolor: "#fff", borderRadius: "8px", width: "100%"
                        }}>
                            <TableBody >
                                {payments.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((payment) => (
                                    <TableRow key={payment.transactionID}>
                                        <TableCell>{payment.transactionID}</TableCell>
                                        <TableCell>{payment.date}</TableCell>
                                        <TableCell>{payment.contentName}</TableCell>
                                        <TableCell>{payment.email}</TableCell>
                                        <TableCell>{payment.totalPaid}</TableCell>
                                        <TableCell>
                                            <Button variant="contained" sx={{
                                                borderRadius: '15px',
                                                width: '154px',
                                                height: '48px',
                                                textTransform: 'none',
                                                backgroundColor: '#233F91',
                                                color: '#FFFFFF',
                                                fontSize: '16px',
                                                fontWeight: 700,
                                                '&:hover': {
                                                    backgroundColor: '#1565c0'
                                                }
                                            }}>
                                                View Receipt
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Paper>
                    </Table>
                </TableContainer>
                <Box mt={2} display="flex" justifyContent="center">
                    <CustomPaginationCommon
                        count={payments.length}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        onPageChange={handleChangePage}
                    />
                </Box> */}
            </Grid>
        </Grid>
    );
};

export default RefundsTable;
